import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review from Beefy's Own's live Faire brand page
// (review token br_qqu5dgvsa4) — verbatim text/name/location, `publish_at`
// date. The live page shows this one with 3 purchased bags (see review_bo1's
// note on why the exact line items aren't resolvable).
export const review_bo3: FaireReviewEntity = {
  token: "review_bo3",
  type: "review",
  brandName: "Beefy's Own",
  brandToken: "b_d6aqh4qdhb",
  reviewerName: "Ryon",
  reviewerLocation: "Banner Elk, NC, United States",
  stars: 5,
  reviewText: "This is the best brand of chips I have ever tried! Great team!",
  reviewDate: "Jun 9, 2026",
  reviewType: "brand",
  purchasedProductTokens: ["p_xz2fzy3cqc", "p_b7tqfj6z9q", "p_6sy6atfkhp"],
  meta: {
    source: "api",
    importedAt: "2026-08-16T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
